import { Stack } from "@mantine/core";

import { useGetAppAdoption } from "../../../api/insights";
import { useGetEvent } from "../../../api/event";
import SectionShell, {
  Stat,
  StatGrid,
  formatNum,
  formatPct,
} from "../SectionShell";
import { ResponsesPieChart } from "../charts";

function AppAdoption({ eventId }) {
  const { data, isPending, isError, error } = useGetAppAdoption(eventId);
  const { data: event } = useGetEvent(eventId);

  const hasSecondaryLanguages =
    Array.isArray(event?.secondaryLanguages) &&
    event.secondaryLanguages.length > 0;

  const checkInUsed = (data?.appActivation?.totalCheckedInAttendees ?? 0) > 0;

  const pieData = (data?.languageDistribution ?? []).map((row) => ({
    name: row.languageName ?? row.language ?? "Unknown",
    value: row.uniqueUsers,
  }));

  return (
    <SectionShell
      id="appAdoption"
      title="App adoption"
      description="Mobile app activation and language distribution during the event."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="appAdoption"
    >
      <Stack gap="md">
        <StatGrid>
          <Stat
            part="activeAppUsers"
            label="Active app users"
            value={formatNum(data?.appActivation?.uniqueAppUsers)}
          />
          {checkInUsed && (
            <Stat
              part="checkedInAttendees"
              label="Checked-in attendees"
              value={formatNum(data?.appActivation?.totalCheckedInAttendees)}
            />
          )}
          {checkInUsed && (
            <Stat
              part="appActivationRate"
              label="App activation rate"
              value={formatPct(data?.appActivation?.activationRate)}
            />
          )}
        </StatGrid>

        {hasSecondaryLanguages && (
          <ResponsesPieChart
            part="languageDistribution"
            title="Language distribution"
            data={pieData}
          />
        )}
      </Stack>
    </SectionShell>
  );
}

export default AppAdoption;
